import React from 'react'
import * as Logger from 'loglevel'

import { Row, Col, Dropdown, Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FilterSearchBar } from '../FilterSearchBar/FilterSearchBar'

import * as DataHandler from './DataHandler'

import './styles.module.scss'

export class MultiValsSelector extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            filterText: '',
            isShow: false
        }

        this.wrapperRef = React.createRef()
    }

    componentDidMount() {
        // for outside clicks:
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        // for outside clicks:
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside = (event) => {
        if (this.state.isShow && !!this.wrapperRef.current) {
            if (
                this.wrapperRef &&
                !this.wrapperRef.current.contains(event.target)
            ) {
                this.setState({ isShow: false })
            }
        }
    }

    setFilterSearchText = (newText) => {
        Logger.debug(newText)
        this.setState({
            filterText: newText
        })
    }

    handleCheckboxChange = (
        event,
        selectedIndex,
        availableVals,
        selectedVals,
        valGroup
    ) => {
        // props:
        // availableVals: [],
        // selectedVals: [],
        // title: "Production Centre",
        // toggleIcon: faCity

        Logger.debug(availableVals)
        Logger.debug(selectedVals)

        var newFilterArr = [] // initialize black array then concat to prevent state mutation
        newFilterArr = newFilterArr.concat(this.props.selectedVals)

        if (valGroup) {
            // if group filter is clicked:
            var isChecked = !event.target.checked // weird behavior, will see why later...
            Logger.debug(valGroup)
            var availableFilterObjsWithSelectedGrpId = availableVals.filter(
                (nodeToFilter) => nodeToFilter.groupIds.includes(valGroup.id)
            )
            if (!isChecked) {
                // select all (if the grp obj is not in objToFilter already, then push it to that ary)
                availableFilterObjsWithSelectedGrpId.forEach(
                    (availableFilterObjWithSelectedGrpId) => {
                        if (
                            !newFilterArr.some(
                                (objToFilter) =>
                                    objToFilter.id === availableFilterObjWithSelectedGrpId.id
                            )
                        ) {
                            newFilterArr.push(availableFilterObjWithSelectedGrpId)
                        }
                    }
                )
            } else {
                // unselectAll
                // filter(filterObj Id != availableFilterObjsWithSelectedGrpId.id)
                // include is basically equivalent to ===... so it works
                newFilterArr = newFilterArr.filter(
                    (filteredObj) =>
                        !availableFilterObjsWithSelectedGrpId.includes(filteredObj)
                )
            }
        } else {
            Logger.debug(selectedVals)
            var foundFilterObj = selectedVals.find(
                (toFilter) => toFilter.id === selectedIndex
            )
            if (foundFilterObj) {
                // if checked object is already in the filter, remove it
                newFilterArr = newFilterArr.filter(
                    (filteredObj) => filteredObj !== foundFilterObj
                )
            } else {
                // if checked object is not in the filter, add it
                var selectedObj = availableVals.find(
                    (availableFilteredVal) => availableFilteredVal.id === selectedIndex
                )
                if (selectedObj) newFilterArr.push(selectedObj)
            }
        }
        /*
            this.setState({
                nodesToFilter: selectedVals == "nodesToFilter" ? newFilterArr : this.state.nodesToFilter,
                categoriesToFilter: selectedVals == "categoriesToFilter" ? newFilterArr : this.state.categoriesToFilter
            }, () => {
                this.onHubNodesSelected(this.state.nodesToFilter, this.state.categoriesToFilter);
                this.props.setSearchAreaFocus(this.state[selectedVals].length > 0 ? HubConstant.HUB_SEARCH_AREA_FOCUS.FILTER : HubConstant.HUB_SEARCH_AREA_FOCUS.NONE);
            }); */
        this.props.setSelectedVals(newFilterArr, this.props.id)
    }

    isGroupChecked = (selectedVals, valGroup) => {
        Logger.debug(selectedVals)
        if (selectedVals.length > 0) {
            var selectedValsOfGroup = selectedVals.filter((nodeToFilter) =>
                nodeToFilter.groupIds.includes(valGroup.id)
            )
            return selectedValsOfGroup.length === valGroup.vals.length
        }
        return false
    }

    renderValCheckboxes(
        availableVals,
        selectedVals,
        filterText,
        valGroups
    ) {
        // props:
        // availableVals: [],
        // selectedVals: [],
        // title: "Production Centre",
        // toggleIcon: faCity
        // filters not being Processed by filterText yet
        var filteredVals = DataHandler.filterAvailableVals(
            availableVals,
            filterText,
            valGroups
        )
        if (
            !!valGroups &&
            availableVals.length > 0 &&
            !!availableVals[0].groupIds
        ) {
            return (
                <div>
                    <div className='filterGroupParent'>Production Groups</div>
                    {DataHandler.getFilteredGroupVals(valGroups, filteredVals).map(
                        (valGroup, index) => {
                            // Have to set a valid id for check box or else it gets mad and unresponsive, with no damn error in console whatsoever
                            return (
                                <div key={`valGroup${index}`}>
                                    <label className='checkboxContainer'
                                        style={this.props.isLoading ? { cursor: 'wait' } : {}}
                                    >
                                        {valGroup.name}
                                        <input
                                            id={`valGroup${index}`}
                                            name={`valGroup${index}`}
                                            className='filterGroupChild'
                                            disabled={this.props.isLoading}
                                            type='checkbox'
                                            onChange={(e) => {
                                                Logger.debug('1')
                                                this.handleCheckboxChange(
                                                    e,
                                                    index,
                                                    availableVals,
                                                    selectedVals,
                                                    valGroup
                                                )
                                            }}
                                            checked={this.isGroupChecked(selectedVals, valGroup)}
                                        />
                                        <span className='checkmark' />
                                    </label>
                                </div>
                            )
                        }
                    )}
                    <div className='filterGroupParent'>Production Centres</div>
                    {filteredVals.map((availableFilteredVal) => {
                        Logger.debug(
                            'Selected? ' +
                            selectedVals.some(
                                (toFilter) => toFilter.id === availableFilteredVal.id
                            )
                        )
                        // Have to set DIFFERENT UNIQUE id for check box or else it gets mad and unresponsive, with no damn error in console whatsoever, or even bind to the other checkbox's onChange function
                        return (
                            <label
                                key={`filterGroupChild${availableFilteredVal.id}`}
                                className='checkboxContainer'
                                style={this.props.isLoading ? { cursor: 'wait' } : {}}
                            >
                                {availableFilteredVal.name}
                                <input
                                    id={`filterGroupChild${availableFilteredVal.id}`}
                                    name={`${availableFilteredVal.id},${availableVals},${selectedVals}`}
                                    disabled={this.props.isLoading}
                                    className='filterGroupChild'
                                    type='checkbox'
                                    onChange={(e) => {
                                        Logger.debug('2')
                                        this.handleCheckboxChange(
                                            e,
                                            availableFilteredVal.id,
                                            availableVals,
                                            selectedVals,
                                            undefined
                                        )
                                    }}
                                    checked={selectedVals.some(
                                        (toFilter) => toFilter.id === availableFilteredVal.id
                                    )}
                                />
                                <span className='checkmark' />
                            </label>
                        )
                    })}
                </div>
            )
        } else
            return filteredVals.map((availableFilteredVal) => {
                // Have to set DIFFERENT UNIQUE id for check box or else it gets mad and unresponsive, with no damn error in console whatsoever, or even bind to the other checkbox's onChange function
                return (
                    <label
                        className='checkboxContainer'
                        key={`availableFilteredVal${availableFilteredVal.id}`}
                        style={this.props.isLoading ? { cursor: 'wait' } : {}}
                    >
                        {availableFilteredVal.name}
                        <input
                            id={availableFilteredVal.id}
                            name={`${availableFilteredVal.id},${availableVals},${selectedVals}`}
                            type='checkbox'
                            disabled={this.props.isLoading}
                            onChange={(e) => {
                                this.handleCheckboxChange(
                                    e,
                                    availableFilteredVal.id,
                                    availableVals,
                                    selectedVals,
                                    undefined
                                )
                            }}
                            checked={selectedVals.some(
                                (toFilter) => toFilter.id === availableFilteredVal.id
                            )}
                        />
                        <span className='checkmark' />
                    </label>
                )
            })
    }

    selectAllFilters = () => {
        this.props.setSelectedVals(this.props.availableVals, this.props.id)
    }

    flushFilters = () => {
        this.props.setSelectedVals([], this.props.id)
    }

    renderAllNoneButtons() {
        return (
            <div className='filterDropdownAllOrNone'>
                <span>Options:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span
                    className={`All ${this.props.selectedVals.length === this.props.availableVals.length
                            ? 'Active '
                            : ''
                        }`}
                    onClick={() => this.selectAllFilters()}
                >
                    All
                </span>{' '}
                &nbsp;&nbsp;
                <span
                    className={`None ${this.props.availableVals.length === 0 ? 'Active ' : ''
                        }`}
                    onClick={() => this.flushFilters()}
                >
                    None
                </span>
            </div>
        )
    }

    arePropsFullyInitialized() {
        var requiredKeys = [
            'id',
            'title',
            'toggleIcon',
            'availableVals',
            'selectedVals',
            'setSelectedVals'
        ]

        var areMissingPropsDetected = false
        for (let i = 0; i < requiredKeys.length; i++) {
            if (this.props[requiredKeys[i]] === undefined) {
                Logger.error(
                    `The prop ${requiredKeys[i]} is missing.  Please add them to ensure that DataEditor is built correctly`
                )
                areMissingPropsDetected = true
            }
        }
        return !areMissingPropsDetected
    }

    render() {
        if (!this.arePropsFullyInitialized())
            return (
                <div style={{ color: 'red' }}>
                    <b>
                        Missing MultiValsSelector Props. Please check the console for more
                        info.
                    </b>
                </div>
            )

        return (
            <Dropdown
                className='filterDropdown'
                show={this.state.isShow}
                ref={this.wrapperRef}
            >
                <Dropdown.Toggle
                    className={`filterDropdownToggle ${this.props.selectedVals.length === 0 ? 'InActive ' : ''
                        }`}
                    onClick={() => {
                        var newIsShow = !this.state.isShow
                        this.setState({ isShow: newIsShow })
                    }}
                    id='dropdown-basic'
                >
                    <FontAwesomeIcon icon={this.props.toggleIcon} />
                    {' ' + this.props.title}
                    <div className='filterCountDisplay'>
                        <span className='filterCount'>
                            {this.props.selectedVals.length}
                        </span>
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className='filterDropdownMenu' style={this.props.isLoading ? { cursor: 'wait' } : {}}>
                    {this.state.isShow ? (
                        <Card className='filterDropdownCard'>
                            <Card.Body>
                                <Row>
                                    <Col xs='12'>
                                        <FilterSearchBar
                                            setSearchText={(newText) =>
                                                this.setFilterSearchText(newText)
                                            }
                                            searchText={this.state.filterText}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs='12'>{this.renderAllNoneButtons()}</Col>
                                </Row>
                                <Row>
                                    <Col xs='12' className='filterCheckboxesContainer'>
                                        {this.renderValCheckboxes(
                                            this.props.availableVals,
                                            this.props.selectedVals,
                                            this.state.filterText,
                                            this.props.valGroups ? this.props.valGroups : undefined
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    ) : (
                        <div />
                    )}
                </Dropdown.Menu>
            </Dropdown>
        )
    }
}